<template>
<section>
    

    <div class="login_wrap">
        <div class="login_topbanner">
            <dl>
                <dt>지금 <span>프리북</span>과<br>상담을 시작하세요.</dt>
                <dd>
                    내가 편한 쇼룸, 내가 택한 사람
                </dd>
            </dl>
            <img :src="`${$store.state.dir}images/login_logo.png`" class="login_logo">
        </div>
        <ul class="login_form">
            <li>
                <input type="text" placeholder="휴대폰 번호" v-model="username">
            </li>
            <li>
                <input type="password" placeholder="비밀번호" v-model="password">
            </li>
            <li class="submit" style="margin-bottom:10px">
                <button @click="validate()">로그인</button>
            </li>
            <li class="find_login_li" style="flex-direction: unset;">
                <router-link to="/join/niceAuth">회원가입</router-link>
                <router-link to="/pw/niceAuth">비밀번호 재설정</router-link>
            </li>
        </ul>

        <div class="easy_login_wrap">
            <p><span>간편 로그인</span></p>
            <div class="easy_login">

                <ul class="easy_login">
                    <li>
                        <a ref="googleLogin" @click="googleOAuth();"><img :src="$store.state.resource.imgIconGoogle" alt="구글 로그인"></a>
                    </li>
                    <li>
                        <a ref="kakaoLogin" @click="kakaoOAuth();"><img :src="$store.state.resource.imgIconKakao" alt="카카오톡 로그인"></a>
                    </li>
                   
                    <li v-if="agentCheck == Const.SOCIAL.IOS">
                        <a ref="appleLogin" @click="appleOAuth();"><img :src="$store.state.resource.imgIconApple" alt="애플 로그인"></a>
                    </li>
                </ul>

                <!-- <ul>
                    <li>
                        <button @click="kakaoLogin()" style="border: none; background-color: transparent;">
                            <img :src="`${$store.state.dir}images/kakao_login_large_wide_kor.png`" alt="카카오톡 로그인" style="width: 100%;">
                        </button>
                    </li>

                    <li>
                        <button id="gLogin" style="border: none; background-color: transparent;">
                            <img :src="`${$store.state.dir}images/google_icon.png`" alt="구글 로그인">
                        </button>
                    </li>

                    <li>
                        <button style="border: none; background-color: transparent;">
                            <img :src="`${$store.state.dir}images/appleid_button.png`" alt="애플 로그인" style="width: 100%;">
                        </button>
                    </li>
                </ul> -->

            </div>
        </div>
        
    </div>
</section>

</template>

<script>
import { SocialMixin } from '../mixins/SocialMixin';

export default 
{
    name:'Login',
    mixins:[SocialMixin],
    created() {
        // this.$store.state.headerBlank = false;
        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
            username: '',
            password: '',
            redirectUrl: '',
        }
    },
    mounted() {
        this.$store.commit('CLEAR_AUTH_WRITE');
    },

    methods: {
        validate() 
        {
            try 
            {
                if (!this.username) throw '핸드폰 번호를 입력해주세요.';
                else if (!this.password) throw '비밀번호를 입력해주세요.';
            } 
            catch (errorMsg) 
            {
                return this.$store.commit('OPEN_MODAL', {
                    content:errorMsg,
                    btnOne:'확인',
                })
            }
            this.submit();
        },

        submit()
        {
            this.$store.dispatch('LOGIN', {
                username: this.username,
                password: this.password,
            })
            .then(()=> {
                this.$router.push('/main');
            })
            .catch((error)=>{
                this.apiCatch(error);
            })
        },        
    },
    
}
</script>

<style scoped>
</style>